import { type AssetInfo, getMyAssets } from "../net/api";
import { $myAssets } from "./stores";

let issued = 0;
let applied = 0;

/**
 * Reads the player's assets into $myAssets. Requests can overlap (an upload panel, an assetsChanged push,
 * the inventory opening) and answer out of order; an answer older than one already shown is dropped, so the
 * shelf never loses a model it just showed.
 */
export async function refreshMyAssets(fetch: () => Promise<AssetInfo[]> = getMyAssets): Promise<void> {
  const n = ++issued;
  const list = await fetch();
  if (n < applied) return;
  applied = n;
  $myAssets.set(list);
}
